import {
	CourseEntity, ICourseEntityAttributes, IGeneratedTermEntityAttributes, IStudyPlanEntityAttributes, StudyPlanEntity,
} from 'Models/Entities';

export enum YearHalf {
	First = 0,
	Second = 1,
}

// terms per period
export enum TermIndex {
	First = 0,
	Second = 1,
	Third = 2,
	Fourth = 3,
	Fifth = 4,
	Sixth = 5,
	Seventh = 6,
	Eighth = 7,
	Ninth = 8,
	Tenth = 9,
}

export type StudyLoadConfig = number[][][];

export interface IGeneratePlanCourse {
	id: string;
	courseEntityId: string;
	courseEntity: CourseEntity;
	studyTermId: string;
}

export interface BaseFeedback {
	id: string;
	title: string;
	description: string;
}

export interface RequisiteWarning extends BaseFeedback {
	courseOfferingId: string;
	courseId: string;
}

export interface IGeneratedPlanFeedback {
	requisiteWarnings: RequisiteWarning[];
}

export interface IGeneratedPlanResponse {
	status: 'HAS_FEEDBACK' | 'SUCCESS';
	feedback: IGeneratedPlanFeedback;
	studyPlan: IStudyPlanEntityAttributes;
	terms: IGeneratedTermEntityAttributes[];
	plannedCourses: IGeneratePlanCourse[];
	completedCourses: {
		id: string;
		courseEntityId: string;
		courseEntity: ICourseEntityAttributes,
		debugCPVCode: string,
	}[]
}

export interface IGeneratedPlan extends IGeneratedPlanResponse {
	studyPlan: StudyPlanEntity;
	studyLoad: StudyLoadConfig;
}
